// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
	production: true,
	isMockEnabled: false,
	authTokenKey: 'authce9d77b308c149d5992a80073637e4d5',
	serverUrl: 'https://prod-admin.imaharah.net/api/',
	fileServerUrl: 'https://prod-fileserver.imaharah.net/api/',
	s3Url: 'https://prod-fileserver.imaharah.net/api/Storages/uploadImage?folder=',
	viewUrl: 'https://maharah-prod-us-east-1-app-files.s3.amazonaws.com/',
	baseUrl: 'https://prod-fileserver.imaharah.net/api/Storages/VendorImages/'
};